import { render, staticRenderFns } from "./VoteRelationChartNet.vue?vue&type=template&id=54db461a&scoped=true"
import script from "./VoteRelationChartNet.vue?vue&type=script&lang=js"
export * from "./VoteRelationChartNet.vue?vue&type=script&lang=js"
import style0 from "./VoteRelationChartNet.vue?vue&type=style&index=0&id=54db461a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54db461a",
  null
  
)

export default component.exports